import { Button, ButtonProps } from '@cmpsr/components';

export default function SaveButton({ ...props }: ButtonProps): React.ReactElement {
  return (
    <Button type="submit" size={{ base: 's', lg: 'm' }} variant="primary" width="100%" {...props}>
      Save
    </Button>
  );
}
